/**
 * Created by Pankaj on 04-Nov-19
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineLite, TweenLite} from "gsap";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {RomanEmpireGameAssets} from "../RomanEmpireGameAssets";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Utils} from "../Utils/Utils";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class ForegroundAnimation extends BaseView {
    private readonly _layer: PIXI.Container;
    private _symSparkleWinAnimations: SparkleAnimation[][] = [];
    private _landingFrameContainer: PIXI.Sprite[][] = [];
    public _stickyFrame: boolean[][] = [];
    public _expandingWildContainer: PIXI.Container;
    public _expanidngWildTl: TimelineLite;
    private _animItemsSpine: any[][] = [];
    private _bothwaysSpriteText: PIXI.Sprite;
    private _gameLogoLeft: PIXI.Sprite;
    private _gameLogoRight: PIXI.Sprite;
    private _portraitLogo: PIXI.Sprite;
    private _reelFrameGlowContainer : PIXI.Container;

    constructor() {
        super();
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.FOREGROUND.name);
        this.addFeatureEventListeners();
    }

    private createGameLogo(): void {
        this._gameLogoLeft = new PIXI.Sprite(GameResources.getTextures("rightLogo")[0]);
        this._gameLogoRight = new PIXI.Sprite(GameResources.getTextures("leftLogo")[0]);
        this._portraitLogo = new PIXI.Sprite(GameResources.getTextures(RomanEmpireGameAssets.INTRO_LOGO)[0]);
        this._portraitLogo.anchor.set(0.5);
        this._portraitLogo.scale.set(0.7);
        this._gameLogoLeft.scale.set(0.85);
        this._gameLogoRight.scale.set(0.85);

        this._layer.addChild(this._gameLogoLeft, this._gameLogoRight, this._portraitLogo);
    }


    public show(i: number, j: number): gsap.Timeline {
        return this._symSparkleWinAnimations[i][j].getAnimationAutoShowHide(true, true);
    }

    public reset(): void {
        this.resetSparkles();
        this.clearAllSymbolFrameAnimation();
    }

    public resetSparkles() {
        this._symSparkleWinAnimations.forEach((reelSymWinAnimations: TimelineSprite[], i: number) => {
            (<SparkleAnimation[]>reelSymWinAnimations).forEach((symWinAnimations: SparkleAnimation) => {
                symWinAnimations.reset();
            });
        });
    }


    protected initAnimations(): void {
        this.createGameLogo();
        this._symSparkleWinAnimations = ArrayHelper.initArrayWithValues(5, (i: number) => {
            const reelAnimations: SparkleAnimation[] = ArrayHelper.initArrayWithValues(3, (j: number) => {
                return new SparkleAnimation(this._layer);
            });
            return reelAnimations;
        });
        this.createSymbolFrameAnimation();

        this.createFrameLandingAnim();

        this.createExpandingWildAnimation();
        this.createBothWaysWinAnimation();
        this.createReelFrameGlow();
    }

    private createReelFrameGlow(){
        this._reelFrameGlowContainer = new PIXI.Container();
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.SYMBOLS.name).addChildAt(this._reelFrameGlowContainer,1);
        this.addReelFrameGlow();
    }

    /**
     * function to create symbol win animations
     */
    private createSymbolFrameAnimation(): void {
        for (let i = 0; i < RomanEmpireGameConfig.instance.REELS_NUM; i++) {
            this._animItemsSpine[i] = [];
            for (let j = 0; j < RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                let spine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("symbolAnimation"));
                this._animItemsSpine[i].push(spine);
                spine.position.set(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                spine.alpha = 0;
                spine.visible = false
                this._layer.addChild(spine);
            }
        }
    }

    /**
     * function clear all landing frame animations on spin start
     */
    private clearAllSymbolFrameAnimation(): void {
        for (let i = 0; i < RomanEmpireGameConfig.instance.REELS_NUM; i++) {
            for (let j = 0; j < RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                this._animItemsSpine[i][j].alpha = 0;
                this._animItemsSpine[i][j].visible = false;
            }
        }
    }

    private createFrameLandingAnim(): void {
        for (let i = 0; i < RomanEmpireGameConfig.instance.REELS_NUM - 1; i++) {
            this._landingFrameContainer[i] = [];
            for (let j = 0; j < RomanEmpireGameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; j++) {
                let symFrame: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("landingFrame")[0]);
                symFrame.position.set(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
                this._layer.addChild(symFrame);
                symFrame.alpha = 0;
                symFrame.visible = false;
                symFrame.anchor.set(0.5);
                symFrame.blendMode = PIXI.BLEND_MODES.ADD;
                this._landingFrameContainer[i].push(symFrame);
            }
        }
    }

    /**
     * function to play landing animation on symbols
     */
    public playLandingFrameAnimation(reelID: number, symbId: number): void {
        let symbol = Reels.getSymbol(reelID, symbId);
        //commented code to fix #193
        // if(WalkingWild.IS_FINAL_MULTIPLIER_MOVING){
        //     symbol?.changeState({
        //         state : RomanEmpireGameConfig.instance.SYMBOL_STATES.normal,
        //         fadeInDuration : 0
        //     });
        // }
        // added below code to fix frame flip issue in m2,m3 landing animation
        this._landingFrameContainer[reelID][symbId].scale.x = Object.is(symbol?.symName, "M2") ? 1 : -1;
        this._landingFrameContainer[reelID][symbId].visible = true;
        TweenLite.to(this._landingFrameContainer[reelID][symbId], 0.1, {alpha: 1});
    }

    /**
     * function to empty landing animation container
     */
    public clearLandingAnimContainers(_landingReelIdAndSymId: number[][]): void {
        for (const iterator of _landingReelIdAndSymId) {
            if (!(this._stickyFrame[iterator[0]][iterator[1]])) {
                this._landingFrameContainer[iterator[0]][iterator[1]].alpha = 0;
                this._landingFrameContainer[iterator[0]][iterator[1]].visible = false;
                let symbol = Reels.getSymbol(iterator[0], iterator[1]);
                //commented code to fix #193
                // if(WalkingWild.IS_FINAL_MULTIPLIER_MOVING){
                //     symbol?.changeState({
                //         state : RomanEmpireGameConfig.instance.SYMBOL_STATES.noWin,
                //         fadeInDuration : 0
                //     });
                // }
            }
        }
    }

    /**
     * function to hide all landing animation objects on all reel spin stopped
     */
    public hideAllLandingAnim(): void {
        for (let i = 0; i < this._landingFrameContainer.length; i++) {
            for (const iterator of this._landingFrameContainer[i]) {
                iterator.visible = false;
                iterator.alpha = 0;
            }
        }

    }

    private addFeatureEventListeners(): void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => {
            this.reset();
        });

        EventHandler.addEventListener(this, ReelEvent.ALL_REELS_SPIN_STOPPED, (event: GameEvent) => {
            this.reset(), this.hideAllLandingAnim();
        });
    }

    protected onResize(data: IResizeData): void {
        if (Object.is(data.orientation, Orientation.LANDSCAPE)) {
            this._portraitLogo.visible = false;
            this._gameLogoLeft.visible = true;
            this._gameLogoRight.visible = true;
            let config = RomanEmpireGameConfig.instance;
            let posY = config.REEL_AREA_POS_Y;
            let leftLogoX = config.REEL_AREA_POS_X - (this._gameLogoLeft.width * 2);
            let rightLogoX = config.REEL_AREA_POS_X + config.REEL_AREA_WIDTH + this._gameLogoRight.width;
            this._gameLogoLeft.position.set(leftLogoX, posY);
            this._gameLogoRight.position.set(rightLogoX, posY);
            if (data.width < 1000) { // added this to fit in logo in 4:3
                this._gameLogoLeft.position.set(leftLogoX + 20, posY);
                this._gameLogoRight.position.set(rightLogoX - 18, posY);
            }

        } else {
            this._gameLogoLeft.visible = false;
            this._gameLogoRight.visible = false;//TODO
            if(data.orientation === Orientation.PORTRAIT){
                if (!(Utils.isDefaultScreenRatio(NolimitApplication.screenBounds))) {
                    this._portraitLogo.visible = false;
                } else {
                    this._portraitLogo.visible = true;
                    this._portraitLogo.position.set(NolimitApplication.screenBounds.center, -this._portraitLogo.height / 2);
                }
            }
        }

        this._symSparkleWinAnimations.forEach((reelSymWinAnimations: TimelineSprite[], i: number) => {
            reelSymWinAnimations.forEach((symWinAnimation: TimelineSprite, j: number) => {
                symWinAnimation.position.set(Helper.getSymbolPositions(i, j)[0], Helper.getSymbolPositions(i, j)[1]);
            });
        });
    }

    /**
     * function to show symbol animation.
     * @param reelId
     * @param symbolId
     * @param symbol
     */
    public getSymbolAnimShow(reelId: number, symbolId: number, symbol?: StateReelSymbol, isReverse? : boolean): TimelineLite {
        let tl: TimelineLite = new TimelineLite();
        this._animItemsSpine[reelId][symbolId].visible = true;
        this._animItemsSpine[reelId][symbolId].scale.x = isReverse ? -1 : 1;
        tl.add(
            new SpineTween(this._animItemsSpine[reelId][symbolId], 0, "animSyms_animation", 0),
        );
        tl.add(() => {
            TweenLite.to(this._animItemsSpine[reelId][symbolId], 0.001, {alpha: 1})
        }, 0);

        return tl;
    }


    public stopExpandWildAnimation() {
        Logger.logDev("expanding wild Logs : stopExpandWildAnimation called");
        if (this._expanidngWildTl) {
            (<PIXI.spine.Spine[]>this._expandingWildContainer?.children).forEach((expandWild: PIXI.spine.Spine, index) => {
                expandWild.skeleton.setSkinByName("default");
                this._expanidngWildTl.add(TweenLite.to(expandWild, 0.3, {alpha: 0}), "end");
            });
        }
    }

    public playExpandWildAnimation(isWinAnim: boolean = false) {
        Logger.logDev("expanding wild Logs : playExpandWildAnimation called");
        if (this._expanidngWildTl?.isActive()) {
            this._expanidngWildTl.pause().kill();
        }

        this._expanidngWildTl = new TimelineLite();
        (<PIXI.spine.Spine[]>this._expandingWildContainer?.children).forEach((expandWild: PIXI.spine.Spine, index) => {
            expandWild.skeleton.setSkinByName("expanding wild");
            if (isWinAnim) {
                this._expanidngWildTl.add(new SpineTween(expandWild, 0, "expanding_wild_loop", 0, 1), 0);
            } else {
                this._expanidngWildTl.add(TweenLite.to(expandWild, 0.001, {alpha: 1}), 0);
                const wildStartST: SpineTween = new SpineTween(expandWild, 0, "expanding_wild_start", 0, 1);
                this._expanidngWildTl.add(wildStartST, 0);
                //this._expanidngWildTl.add(this.showBothWaysAnimation(), 1);
                const wildLoopST = new SpineTween(expandWild, 0, "expanding_wild_loop", 0, 1);
                this._expanidngWildTl.add(wildLoopST, wildStartST.totalDuration());
                this._expanidngWildTl.add(new SpineTween(expandWild, 0, "expanding_wild_smoke_loop", -1, 1), wildStartST.totalDuration() + wildLoopST.totalDuration());
                this._expanidngWildTl.add(this.showBothWaysAnimation(), 1);
            }
        });
        //this._expanidngWildTl.add(this.showBothWaysAnimation(), 1);
        this._expanidngWildTl.add("end");
        this._expanidngWildTl.play();
    }

    private createExpandingWildAnimation() {
        if (!this._expandingWildContainer) {
            this._expandingWildContainer = new PIXI.Container();
            this._expandingWildContainer.name = "EXPANDING_WILD_CONTAINER";
            this._layer.addChild(this._expandingWildContainer);
        }
        const expandingWild2ndReel: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("expandingWild"));
        const expandingWild4thReel: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("expandingWild"));
        this._expandingWildContainer.addChild(expandingWild2ndReel, expandingWild4thReel);
        expandingWild2ndReel.alpha = 0;
        expandingWild4thReel.alpha = 0;
        let pos = Helper.getSymbolPositions(1, 1);
        expandingWild2ndReel.position.set(pos[0], pos[1]);
        pos = Helper.getSymbolPositions(3, 1);
        expandingWild4thReel.position.set(pos[0], pos[1]);
    }

    private _bothWaysText: PIXI.Text;
    private _bothWaysContainer: PIXI.Container;
    private _bothWaysTextBackground: PIXI.Sprite;
    private _leftArrow: PIXI.Sprite; // left is at 0 , right is at 1;
    private _righttArrow: PIXI.Sprite; // left is at 0 , right is at 1;
    private createBothWaysWinAnimation(): void {
        let pos = Helper.getSymbolPositions(2, 1);
        this._bothwaysSpriteText = new PIXI.Sprite(GameResources.getTextures("bothWaysAnimation/BothWays")[0])
        this._bothWaysContainer = new PIXI.Container();
        this._layer.addChild(this._bothWaysContainer);

        this._leftArrow = new PIXI.Sprite(GameResources.getTextures("bothWaysAnimation/Arrow")[0])
        this._righttArrow = new PIXI.Sprite(GameResources.getTextures("bothWaysAnimation/Arrow")[0])

        this._bothWaysTextBackground = new PIXI.Sprite(GameResources.getTextures("bothWaysAnimation/black_strip")[0]);
        this._bothWaysTextBackground.alpha = 0.8;
        this._bothWaysTextBackground.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        this._bothWaysTextBackground.anchor.set(0.5);
        this._bothWaysTextBackground.position.set(pos[0], pos[1]);

        this._bothWaysText = new PIXI.Text(Translation.translate("Both ways!"), {
            dropShadow: true,
            dropShadowAngle: 8,
            dropShadowBlur: 10,
            dropShadowDistance: 2,
            fontFamily: "Open Sans",
            fontStyle: FontStyle.ITALIC,
            fontWeight: FontWeight.EXTRA_BOLD,
            fontSize: 40,
            fill: [
                "white",
                "#fffb00",
                "#ff9300"
            ]
        });

        this._righttArrow.anchor.set(0.5);
        this._leftArrow.anchor.set(0.5);
        this._bothWaysText.anchor.set(0.5);
        this._bothwaysSpriteText.anchor.set(0.5);
        this._bothwaysSpriteText.scale.set(0.5);

        this._righttArrow.angle = 180;

        this._bothwaysSpriteText.position.set(pos[0] - 3, pos[1]);
        this._bothWaysText.position.set(pos[0], pos[1]);
        this._leftArrow.position.set(pos[0] / 2.5, pos[1]);
        this._righttArrow.position.set(pos[0] * 1.58, pos[1]);

        this._leftArrow.alpha = 0;
        this._righttArrow.alpha = 0;
        this._bothWaysContainer.alpha = 0;

        this._bothWaysContainer.addChild(this._bothWaysTextBackground, this._bothWaysText, this._bothwaysSpriteText);
        this._layer.addChild(this._leftArrow, this._righttArrow);
    }

    private showBothWaysAnimation(): TimelineLite {

        const pos = Helper.getSymbolPositions(2, 1);
        if (SlotGame.api.options.language === "en") {
            this._bothwaysSpriteText.visible = true;
            this._bothWaysText.visible = false;
            this._leftArrow.position.set(pos[0] / 2.5, pos[1]);
            this._righttArrow.position.set(pos[0] * 1.58, pos[1]);

        } else {
            this._bothwaysSpriteText.visible = false;
            this._bothWaysText.visible = true;
            this._leftArrow.position.set(pos[0] - this._leftArrow.width * 0.5 - this._bothWaysText.width*0.5 - 30, pos[1]);
            this._righttArrow.position.set(pos[0] + this._righttArrow.width * 0.3 + this._bothWaysText.width*0.6 + 30, pos[1]);
        }
        // let pos = Helper.getSymbolPositions(2, 1);
        // this._leftArrow.position.set(pos[0] / 2.5, pos[1]);
        // this._righttArrow.position.set(pos[0] * 1.58, pos[1]);
        let tl: TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.fromTo(this._leftArrow, 1.5, {x: this._leftArrow.x}, {x: this._leftArrow.x + 30}),
            TweenLite.fromTo(this._leftArrow, 1.5, {alpha: 0}, {alpha: 1}),
            TweenLite.fromTo(this._righttArrow, 1.5, {x: this._righttArrow.x}, {x: this._righttArrow.x - 30}),
            TweenLite.fromTo(this._righttArrow, 1.5, {alpha: 0}, {alpha: 1})
        ]);
        tl.add(() => {
            TweenLite.to(this._bothWaysContainer, 0.5,
                {
                    alpha: 1
                });
        }, 0.5);
        tl.add([
            TweenLite.fromTo(this._leftArrow, 1.5, {x: this._leftArrow.x + 30}, {x: this._leftArrow.x - 30}),
            TweenLite.to(this._leftArrow, 1.5, {alpha: 0}),
            TweenLite.fromTo(this._righttArrow, 1.5, {x: this._righttArrow.x - 30}, {x: this._righttArrow.x + 30}),
            TweenLite.to(this._righttArrow, 1.5, {alpha: 0})
        ], 2.5);

        tl.add(() => {
            this.hideBothWaysAnimation();
        }, 3);
        return tl;
    }

    private hideBothWaysAnimation(): void {
        this._bothWaysContainer.alpha && TweenLite.to(this._bothWaysContainer, 0.5, {alpha: 0})
        //     this._leftArrow.alpha && TweenLite.to(this._leftArrow, 0.5, {alpha: 0})
        //     this._righttArrow.alpha && TweenLite.to(this._righttArrow, 0.5, {alpha: 0})
    }

    public showReelFrameGlow() : TweenLite{
        return TweenLite.fromTo(this._reelFrameGlowContainer,0.1,{alpha:0},{alpha : 1,onStart:()=>{
                this._reelFrameGlowContainer.visible = true;
            }});
    }

    public hideReelFrameGlow(): TweenLite{
        return TweenLite.fromTo(this._reelFrameGlowContainer,0.1,{alpha:1},{alpha : 0, onComplete:()=>{
                this._reelFrameGlowContainer.visible = false;
            }});
    }

    private addReelFrameGlow() {
        const reelFrameGlow = new PIXI.Sprite(GameResources.getTextures("reelFrameGlow")[0]);
        reelFrameGlow.anchor.set(1,0);
        reelFrameGlow.position.y = -107;
        //reelFrameGlow.position.set(-210,-7);
        const reelFrameGlowReverse = new PIXI.Sprite(GameResources.getTextures("reelFrameGlow")[0]);
        reelFrameGlowReverse.anchor.set(1,0);
        reelFrameGlowReverse.scale.x = -1;
        reelFrameGlowReverse.position.y = -107;
        reelFrameGlowReverse.position.x = -1;
        this._reelFrameGlowContainer.addChild(reelFrameGlow, reelFrameGlowReverse);
        this._reelFrameGlowContainer.position.set(RomanEmpireGameConfig.instance.REEL_AREA_CENTER_X, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y);
        this._reelFrameGlowContainer.visible = false;
    }
}


export class SparkleAnimation extends TimelineSprite {
    constructor(layer: PIXI.Container, textures: PIXI.Texture[] = GameResources.getTextures("sparklesWinAnimation"), sourceFPS: number = 30) {
        super(textures, sourceFPS);
        this.init();
        layer.addChild(this);
    }

    private init() {
        this.anchor.set(0.5, 0.5);
        this.position.set(0, 0);
        this.hide();
        this.blendMode = PIXI.BLEND_MODES.ADD;
    }

    public reset() {
        this.stopLoop();
        this.hide();
    }
}
